import { defineRouteTree, route } from "./lib"

export const routeTree = defineRouteTree({
  root: route("/"),
  devPlayground: route("/dev-playground"),
  auth: route("/auth"),
  export: route("/export"),
  error: route("/error"),
  notFound: route("/not-found"),
  catchAll: route("*"),
})
